<template>
  <div class="home">
    <v-carousel hide-delimiters cycle>
      <v-carousel-item v-for="(item, i) in items" :key="i" :src="item.src">
        <v-row class="fill-height" align="center" justify="center">
          <div class="text-h1 white--text">
            {{ item.title }}
          </div>
        </v-row></v-carousel-item
      >
    </v-carousel>
    <v-card>
      <v-card-title class="display-3">
        Asiatischer Wein
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="desserts"
        :search="search"
        :items-per-page="-1"
        ><template v-slot:item.aperitif="{ item }">
          <b>{{ item.aperitif }}</b>
        </template>
        <template v-slot:item.preis="{ item }">
          <b>{{ item.preis }}</b>
        </template></v-data-table
      >
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'Asiatischerwein',
  data() {
    return {
      items: [
        {
          src: require('../assets/images/sakeasiatisch.jpg'),
          title: '',
        },
        {
          src: require('../assets/images/pflaumenwein.jpg'),
          title: '',
        },
      ],
      search: '',
      headers: [
        { text: 'Aperitifs', value: 'aperitif' },
        { text: 'Menge', value: 'menge' },
        { text: 'Preis', value: 'preis' },
      ],
      desserts: [
        {
          aperitif: 'Pflaumenwein',
          menge: '8 cl',
          preis: '4,00 €',
        },
        // {
        //   aperitif: 'Sake',
        //   menge: '8 cl',
        //   preis: '4,00 €',
        // },
      ],
    };
  },
  methods: {
    top() {
      window.scrollTo(0, 0);
    },
  },
  created() {
    this.top();
  },
};
</script>

<style lang="scss" scoped></style>
